/**
 * Created by sange on 15/09/2017.
 */

export enum JeanMessageConfirmationType {
  Nack = 0,
  Ack = 1,
  Unconfirmed = 2,
  Read = 3,
}




// WEBPACK FOOTER //
// ./src/app/shared/conversation/jean-message-confirmation-type.ts